import axios from "axios";
import { backendURL } from "../url";
import { passSelectedDate } from "../hooks/Date";

const API_URL = "/api/booking";

export const getAllBookings = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(
      // `${process.env.REACT_APP_BACKEND_URL}${API_URL}/get-all-bookings`,
      `${backendURL}${API_URL}/get-new-bookings`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Error fetching bookings:", error.message);
    throw error;
  }
};
// export const getAllBookings = async () => {
//   const token = localStorage.getItem("token");
//   try {
//     const response = await axios.get(
//       // `${process.env.REACT_APP_BACKEND_URL}${API_URL}/get-all-bookings`,
//       `${backendURL}${API_URL}/get-all-bookings`,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//     return response.data;
//   } catch (error: any) {
//     console.error("Error fetching bookings:", error.message);
//     throw error;
//   }
// };

export const getBookingsByUser = async () => {
  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");
  try {
    const response = await axios.post(
      `${backendURL}${API_URL}/get-bookings-by-user`,
      // `${process.env.REACT_APP_BACKEND_URL}${API_URL}/get-bookings-by-user/${userId}`,
      {
        userId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 403) {
      localStorage.clear();
    }
    return response.data;
  } catch (error: any) {
    console.error("Error fetching bookings:", error.message);
    throw error;
  }
};
// export const getBookingsByUser = async () => {
//   const userId = localStorage.getItem("userId");
//   const token = localStorage.getItem("token");
//   try {
//     const response = await axios.get(
//       `${backendURL}${API_URL}/get-bookings-by-user/${userId}`,
//       // `${process.env.REACT_APP_BACKEND_URL}${API_URL}/get-bookings-by-user/${userId}`,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//     if (response.status === 403) {
//       localStorage.clear();
//     }
//     return response.data.booking;
//   } catch (error: any) {
//     console.error("Error fetching bookings:", error.message);
//     throw error;
//   }
// };

export const cancelBooking = async (
  chargeId: string,
  email: string,
  listingName?: string,
  firstName?: string,
  lastName?: string,
  totalHours?: number,
  totalAmount?: number,
  bookingForDate?: string,
  startTime?: string,
  endTime?: string
) => {
  const token = localStorage.getItem("token");
  try {

    console.log("Booking for date:", bookingForDate);
    const response = await axios.post(
      `${backendURL}${API_URL}/create-refund`,
      // `${process.env.REACT_APP_BACKEND_URL}${API_URL}/create-refund`,
      {
        chargeId,
        email,
        listingName,
        firstName,
        lastName,
        totalHours,
        totalAmount,
        bookingForDate,
        startTime,
        endTime,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Error fetching bookings:", error.message);
    throw error;
  }
};

export const updateBooking = async (
  bookingId: string,
  bookingStatus: string,
  email?: string,
  listingName?: string,
  firstName?: string,
  lastName?: string,
  totalHours?: number,
  totalAmount?: number,
  bookingForDate?: string,
  startTime?: string,
  endTime?: string,
  laneOrCageId?: string,
  specialRequests?: string
) => {
  const token = localStorage.getItem("token");

  try {
    // Only include dateTimes if we're actually updating date/time values
    const requestBody: any = {
      bookingId,
      bookingStatus,
      email,
      listingName,
      firstName,
      lastName,
      totalHours,
      totalAmount,
      laneOrCageId,
      specialRequests,
    };

    // Only add dateTimes if we have actual date/time values to update
    // For status-only updates, don't include dateTimes at all
    if (bookingForDate && startTime && endTime) {
      requestBody.dateTimes = [
        {
          date: passSelectedDate(bookingForDate, startTime),
          startTime,
          endTime,
        }
      ];
    }

    console.log("Sending update request:", requestBody);

    const response = await axios.put(
      `${backendURL}${API_URL}/update-booking`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Error updating booking:", error.message);
    throw error;
  }
};

export const getAvailableSlots = async (
  selectedDate: string,
  laneOrCageId: string
) => {
  try {
    // Parse the date string directly without timezone conversion
    const [year, month, day] = selectedDate.split('-').map(Number);
    const dateToSend = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    
    const response = await axios.post(
      `${backendURL}${API_URL}/get-booked-slots`,
      {
        datesToCheck: [dateToSend],
        laneOrCageId,
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Error fetching available slots:", error.message);
    throw error;
  }
};


export const bookingByAdmin = async (data: any) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.post(
      // `${process.env.REACT_APP_BACKEND_URL}${API_URL}/booking-by-admin`,
      `${backendURL}${API_URL}/booking-by-admin`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Error fetching bookings:", error.message);
    throw error;
  }
};

export const remindUser = async (
  listingName: string,
  name: string,
  email: string,
  bookingForDate: string,
  startTime: string,
  endTime: string
) => {
  const token = localStorage.getItem("token");
  const data = {
    listingName,
    name,
    email,
    bookingForDate,
    startTime,
    endTime,
  };
  try {
    const response = await axios.post(
      `${backendURL}${API_URL}/remind-user`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Error fetching bookings:", error.message);
    throw error;
  }
};

export const checkAvailableSlots = async (
  laneOrCageId: string,
  startTime: string,
  endTime: string,
  selectedDate?: string,
  selectedDates?: string[],
  dateRange?: { startDate: string; endDate: string }
) => {
  const token = localStorage.getItem("token");
  try {
    const payload: any = {
      laneOrCageId,
      startTime,
      endTime
    };

    // Add the appropriate date parameter based on what's provided
    if (selectedDate) {
      payload.selectedDate = selectedDate;
    } else if (selectedDates && selectedDates.length > 0) {
      payload.selectedDates = selectedDates;
    } else if (dateRange && dateRange.startDate && dateRange.endDate) {
      payload.dateRange = dateRange;
    }

    const response = await axios.post(
      `${backendURL}${API_URL}/available-slots`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Error checking available slots:", error.message);
    throw error;
  }
};
